import React from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { EditOutlined, DeleteOutlined } from "@material-ui/icons";

const Relatorio = ({
  relatorio,
  index,
  handleEdit,
  handleOpenExclusaoRelatorio,
}) => {
  return (
    <div
      className={
        index % 2 === 0
          ? "row mt-0 d-flex align-items-center medium-row tr-even-adm"
          : "row mt-0 d-flex align-items-center medium-row tr-odd"
      }
    >
      <div className="col-2 col-md-2 mt-sm-2 mt-lg-0 user-table ">
        <span>{relatorio.codigo}</span>
      </div>
      <div className="col-3 col-md-3 mt-sm-3 mt-lg-0 user-table ">
        <span>{relatorio.nome}</span>
      </div>
      <div className="col-3 col-md-3 my-3 my-lg-0 user-table">
        <span>{relatorio.idWorkspace}</span>
      </div>
      <div className="col-3 col-md-3 my-3 my-lg-0 user-table">
        <span>{relatorio.idRelatorio}</span>
      </div>
      <Tooltip title="Editar">
        <IconButton className="p-2" onClick={() => handleEdit(relatorio)}>
          <EditOutlined className={"color-black"} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Excluir">
        <IconButton
          className="p-2"
          onClick={() => handleOpenExclusaoRelatorio(relatorio)}
        >
          <DeleteOutlined className={"color-black"} />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default Relatorio;
